import { render, staticRenderFns } from "./AmountIputGroup.vue?vue&type=template&id=57ed32f0&scoped=true&"
import script from "./AmountIputGroup.vue?vue&type=script&lang=js&"
export * from "./AmountIputGroup.vue?vue&type=script&lang=js&"
import style0 from "./AmountIputGroup.vue?vue&type=style&index=0&id=57ed32f0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed32f0",
  null
  
)

export default component.exports